import { Link } from 'react-router-dom';

// material-ui
import { Box, Button, Grid, Stack, Typography } from '@mui/material';

// assets
import error404 from 'assets/images/Error404.png';
import TwoCone from 'assets/images/TwoCone.png';
import { useTranslation } from 'react-i18next';

// ==============================|| ERROR 404 - MAIN ||============================== //

function Error404() {
  const { t } = useTranslation();
  return (
    <>
      <Grid
        container
        spacing={10}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh', pt: 1.5, pb: 1, overflow: 'hidden' }}
      >
        <Grid item xs={12}>
          <Stack direction="row">
            <Grid item>
              <Box sx={{ width: { xs: 250, sm: 590 }, height: { xs: 130, sm: 300 } }}>
                <img src={error404} alt="mantis" style={{ width: '100%', height: '100%' }} />
              </Box>
            </Grid>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack spacing={2} justifyContent="center" alignItems="center">
            <Typography variant="h1">{t('message.common.error404.title')}</Typography>
            <Typography color="textSecondary" align="center" sx={{ width: { xs: '73%', sm: '61%' } }}>
              {t('message.common.error404.description')}
            </Typography>
            <Button component={Link} to="/" variant="contained">
              {t('message.common.error404.backToHome')}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}

export default Error404;
